// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1WdQX","paramInput":"JobSimulator_paramInput__akuAv","input":"JobSimulator_input__1ULO2"};